// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"bd088ccc","278":"6ded6ca1","296":"e5c6aea6","359":"62cb21f4","537":"03f9f2b7","564":"9629ea61","602":"d40fa25b","651":"2950fcf0","656":"3639cfb7","781":"f0d6ab91","887":"8641ac9b"}[chunkId] + ".chunk.js";
};